import React, { useState } from "react";
import Aperitivi from "../assets/Antipasti.png";
import Antipasti from "../assets/Aperitivi.png";
import Primi from "../assets/Primi.png";
import Secondi from "../assets/Secondi.png";
import PizzeImage1 from "../assets/Pizze1.png";
import PizzeImage2 from "../assets/Pizze2.png";
import DrinkImage1 from "../assets/Vini.png";
import DrinkImage2 from "../assets/Bevande.png";
import DolciImage from "../assets/Dolci.png";
import { ChevronDownIcon } from "lucide-react";

// Menu categories with their respective images in English and Swedish
const menuItems = {
  "Aperitivi & Antipasti": {
    en: [Antipasti, Aperitivi],
    sv: [Antipasti, Aperitivi],
  },
  "Primi & Secondi/Contorni": {
    en: [Primi, Secondi],
    sv: [Primi, Secondi],
  },
  Pizze: {
    en: [PizzeImage1, PizzeImage2],
    sv: [PizzeImage1, PizzeImage2],
  },
  "Vini & Bevande": {
    en: [DrinkImage1, DrinkImage2],
    sv: [DrinkImage1, DrinkImage2],
  },
  Dolci: {
    en: [DolciImage],
    sv: [DolciImage],
  },
};

export const Menu = () => {
  const [selectedMenu, setSelectedMenu] = useState("Aperitivi & Antipasti");
  const [language, setLanguage] = useState("sv");

  const renderImages = (category) => {
    if (!category) return null;

    return (
      <div className="menu-item text-center flex flex-col md:flex-row justify-center items-center w-full">
        {menuItems[category][language].map((imgSrc, index) => (
          <img
            key={index}
            src={imgSrc}
            alt={category}
            className="w-full sm:w-1/2 h-auto object-cover mb-3"
          />
        ))}
      </div>
    );
  };

  return (
    <div className="container mx-auto px-4 py-8 pt-28">
      {/* Language Switcher with Flags and Text */}
      {/* <div className="flex justify-center  mb-8 space-x-4 sm:space-x-6">
        <button
          onClick={() => setLanguage("en")}
          className={`px-4 py-2 bg-transparent border-2 ${
            language === "en" ? "border-stone-800" : "border-transparent"
          } text-stone-800 rounded-md hover:bg-stone-100 transition-all duration-300 ease-in-out w-24 text-center flex items-center justify-center transform ${
            language === "en" ? "scale-110" : ""
          }`}
        >
          🇬🇧 <span className="ml-2">EN</span>
        </button>
        <button
          onClick={() => setLanguage("sv")}
          className={`px-4 py-2 bg-transparent border-2 ${
            language === "sv" ? "border-stone-800" : "border-transparent"
          } text-stone-800 rounded-md hover:bg-stone-100 transition-all duration-300 ease-in-out w-24 text-center flex items-center justify-center transform ${
            language === "sv" ? "scale-110" : ""
          }`}
        >
          🇸🇪 <span className="ml-2">SV</span>
        </button>
      </div> */}

      {/* Mobile Dropdown Selector */}
      <div className="sm:hidden mb-8 relative">
        <select
          value={selectedMenu}
          onChange={(e) => setSelectedMenu(e.target.value)}
          className="w-full p-4 text-lg bg-transparent border-2 border-stone-800 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-stone-800 appearance-none"
        >
          <option value="" disabled>
            {language === "en" ? "Select a category" : "Välj kategori"}
          </option>
          {Object.keys(menuItems).map((category) => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>
        <ChevronDownIcon className="absolute right-4 top-1/2 transform -translate-y-1/2 text-stone-800" />
      </div>

      {/* Menu Category Buttons (Desktop and Tablet) */}
      <div className="hidden sm:flex justify-center mb-8 space-x-6">
        {Object.keys(menuItems).map((category) => (
          <button
            key={category}
            onClick={() => setSelectedMenu(category)}
            className={`relative text-lg px-8 py-3 font-aboreto tracking-wider transition-all duration-300 ease-in-out ${
              selectedMenu === category
                ? "text-stone-800 border-b-2 border-stone-800"
                : "text-stone-800 border-b-2 border-transparent hover:border-stone-800 hover:bg-stone-100"
            } focus:outline-none`}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Render images for the selected category */}
      {renderImages(selectedMenu)}
    </div>
  );
};
